import { render, staticRenderFns } from "./TipsPopup.vue?vue&type=template&id=6d40fd0b&scoped=true"
import script from "./TipsPopup.vue?vue&type=script&lang=js"
export * from "./TipsPopup.vue?vue&type=script&lang=js"
import style0 from "./TipsPopup.vue?vue&type=style&index=0&id=6d40fd0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d40fd0b",
  null
  
)

export default component.exports